import { ProviderConnectionInfo } from "@/types/integrations";
import { atomWithStorage, createJSONStorage } from "jotai/utils";

const storage = createJSONStorage<ProviderConnectionInfo | null>(
  () => sessionStorage,
);

export const connectionInfoAtom =
  atomWithStorage<ProviderConnectionInfo | null>(
    "cachedConnectionInfo",
    null,
    storage,
    {
      getOnInit: true,
    },
  );
